<template>
    <div class="image-uploader" v-bind:class="{ smaller: small }">
        <div class="iu-placeholder" v-bind:class="{ active: showPlaceholder, small: small, disabled: !enabled }">
            <button
                type="button"
                v-if="enabled"
                v-bind:class="{ 'fluke-btn': !small, 'fluke-btn-small': small }"
                v-on:click="selectFile">

                <i v-if="small" class="material-icons">edit</i>
                <span v-else>SELECIONAR IMAGEM</span>
            </button>
        </div>
        <div class="iu-content" v-bind:class="{ active: !showPlaceholder, small: small, disabled: !enabled }">
            <button
                type="button"
                v-if="enabled"
                v-bind:class="{ 'fluke-btn': !small, 'fluke-btn-small': small }"
                v-on:click="clearFile">
                <i v-if="small" class="material-icons">close</i>
                <span v-else>TIRAR IMAGEM</span>
            </button>
            <button
                type="button"
                v-if="enabled"
                v-bind:class="{ 'fluke-btn': !small, 'fluke-btn-small': small }"
                v-on:click="selectFile">
                <i v-if="small" class="material-icons">edit</i>
                <span v-else>MUDAR IMAGEM</span>
            </button>
        </div>
        <input
            type="file"
            v-on:change="uploadFile" />
        <image-picker
            v-model="fileAddress"
            ref="imagepicker">
        </image-picker>
    </div>
</template>

<style lang="scss">
.image-uploader
{
    padding-top: 20px;

    .iu-content,
    .iu-placeholder {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 80px;
        background-color: $main-background;
        margin-bottom: 20px;
        transition: all 0.5s;
        overflow: hidden;
        height: 0;
        margin-bottom: 0;

        @extend %default-borderRadius;

        &.disabled {
            opacity: .4;
        }
        &.active
        {
            height: 80px;
            margin-bottom: 20px;
        }

        &.small
        {
            width: 100px;
            border-radius: 80px;
            i
            {
                font-size: 20px;
            }

            &.active
            {
                height: 100px;
            }
        }

        button {
            background-color: #e0e0e0;
            box-shadow: none;
            margin: 0 5px;

            &:hover
            {
                background-color: $accent-color;

                @extend %default-shadow;
            }
        }
    }
    .iu-content
    {
        background-size: cover;
        background-position: center;

        &.active
        {
            height: 150px;
            margin-bottom: 20px;
        }
    }
    input {
        display: none;
    }

    .fluke-btn-small
    {
        width: 30px;
        height: 30px;
        border-radius: 15px;
    }
}
</style>

<script>
import Selector from '../../../../helpers/selector.js';
import axios from 'axios';
import ImagePicker from '../ImageGallery/ImageGallery';

export default {
    props: [ 'disabled' ],
    mixins: [
        Selector
    ],
    components: {
        ImagePicker
    },
    data: function()
    {
        return {
            inputFile: null,
            fileAddress: '',
            showPlaceholder: true,
            file: '',
            small: false,
            enabled: true
        }
    },
    watch: {
        file: function()
        {
            this.$attrs.value = this.file;
            this.$emit('input', this.file);
        },
        '$attrs': function()
        {
            if( this.$attrs.value )
            {
                this.fileAddress = this.$myServerAddresses.images + 'img/' + this.$attrs.value;
                this.showDivImage( true );
            }
            if( this.$props.disabled === true ) this.enabled = false;
            else this.enabled = true;
        },
        fileAddress: function()
        {
            this.setFileName();
        }
    },
    created: function() {
        if( typeof this.$attrs.mode !== 'undefined' && this.$attrs.mode == 'small' )
        {
            this.small = true;
        }
        if( this.$props.disabled === true ) this.enabled = false;
    },
    methods: {
        getInputFile: function ()
        {
            if( this.inputFile === null )
            {
                this.inputFile = this.$el.children[2];
            }
            return this.inputFile;
        },
        selectFile: function()
        {
            this.$refs.imagepicker.open();
        },
        uploadFile: function()
        {
            var formData = new FormData();
            formData.append( 'files', this.getInputFile().files[0] );

            var config = {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'X-Fluke': this.$cookies.get('token'),
                }
            };

            axios
                .post( this.$myServerAddresses.images, formData, config )
                .then( result => {
                    if( result.data.success )
                    {
                        this.fileAddress = result.data.file;
                        this.setFileName();
                    }
                })
                .catch( err => {
                    console.log( err );
                })
        },
        clearFile: function()
        {
            var item = this.getInputFile();
            item.value = '';

            if(!/safari/i.test(navigator.userAgent)){
                input.type = ''
                input.type = 'file'
            }

            this.showDivImage( false );
            this.fileAddress = '';
            this.setFileName();
            this.$emit('input', this.file);
        },
        showDivImage: function( show )
        {
            if( show )
            {
                this.$el.children[1].style.backgroundImage = 'url(' + this.fileAddress + ')';
                this.showPlaceholder = false;
            }
            else
            {
                this.showPlaceholder = true;
            }

        },
        setFileName: function()
        {
            var fileAddressArr = this.fileAddress.split('/');
            if( typeof fileAddressArr[4] !== 'undefined' )
            {
                this.file = fileAddressArr[4];
            } else {
                this.file = '';
            }
        }
    }
}
</script>
